var _defs, _path, _path2, _g, _g2, _g3, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500.1 353.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st4 {\n        fill: #ffd400;\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 6.3,
    y1: 244.1,
    x2: 100.5,
    y2: 371.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0b000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2b500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f2d800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f5dd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#efd500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e0c200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#dbbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#e8cc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f9df00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ffe600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fee500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#eac000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e3b200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 9.7,
    y1: 227,
    x2: 62.3,
    y2: 227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff206"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff41a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fffa5e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f6e53c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#eed11b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e9c507"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e8c100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#eccb00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9e500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: -2.6,
    y1: 353.7,
    x2: 71.2,
    y2: 230.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3b200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebc500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f6de00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fcec00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff40c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff92c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fffa2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff721"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e6bf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b38000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 61.8,
    y1: 250.1,
    x2: 61.8,
    y2: 250.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0b07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe100c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fa3230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f74c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f55f60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f46a6c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f46e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f55e5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f93635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff0300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 6.1,
    y1: 239.5,
    x2: 69.1,
    y2: 239.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff86f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff89b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff9bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#fff9db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fff9fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fffaff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff9ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff8c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fff680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fbe100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4b700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2ad00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500.1,275.4v43.2c0,6.1-4.9,11-11,11H59.5c-6.1,0-11-4.9-11-11v-41.1c0-5.7-4.6-10.4-10.4-10.4h-10.6c-5.7,0-10.4-4.6-10.4-10.4v-21.8c0-5.7,4.6-10.4,10.4-10.4h19.9c5.7,0,10.4,4.6,10.4,10.4v19c0,5.7,4.6,10.4,10.4,10.4h420.9c6.1,0,11,4.9,11,11h0,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.7,5.9c2.2,2.5,3.3,5.7,3.3,9.5s-1.1,6.9-3.3,9.3c-2.2,2.4-5.1,3.6-8.6,3.6h-9.2v-4.2h9.2c2.3,0,4.2-.8,5.6-2.3,1.4-1.6,2.1-3.7,2.1-6.4s-.7-4.8-2.2-6.4c-1.4-1.6-3.3-2.4-5.6-2.4h-9.2V2.1h9.2c3.6,0,6.4,1.3,8.6,3.8h0ZM134.3,2.1h-8.7v4.4h8.7c2.3,0,4.1.8,5.6,2.4,1.5,1.6,2.2,3.7,2.2,6.4v12.8h4.1v-12.8c0-3.8-1.1-7-3.2-9.5-2.2-2.5-5.1-3.8-8.6-3.8h0ZM92.4,2.8c-.9-.4-2.1-.8-3-.8h-1v4.2l.8.2c1.8.4,3.1,1.4,3.8,3,.6,1.4.9,3.3.9,5.9v8.9h-5.5v4.2h9.6v-13c0-2.6-.4-5-1.1-7-1-2.7-2.5-4.5-4.6-5.4,0,0,0,0,0,0ZM79.6,28.2h4.2V2.1h-4.2v26.1ZM172.2,12.9c1.5-2.1,2.3-4.8,2.3-8.2v-2.5h-4.2v1.1c.2,2.5,0,4.6-.8,6.2-.9,2-2.2,3-4.2,3h-1.9l-9.2-10.2h-5.9l19.8,21.9h-17.3v4.2h23.8v-3.5l-7.7-8.5c2.2-.4,3.9-1.5,5.3-3.3h0s0,0,0,0ZM64,1.8c-3.4,0-6.3,1.2-8.5,3.7-2.2,2.4-3.3,5.6-3.3,9.4v9.1h-3.6v4.2h7.8v-13.2c0-2.6.7-4.7,2.1-6.3,1.4-1.6,3.2-2.4,5.5-2.4,4.8,0,7.6,3.3,7.6,8.7v13.2h4.2v-13.2c0-3.8-1.1-6.9-3.2-9.3-2.2-2.5-5-3.8-8.5-3.8h0ZM258.9,28.2h4.1V2.1h-4.1v26.1ZM288.4,5.6c-2.2-2.5-5.1-3.8-8.6-3.8s-4.1.6-6,1.7c-.7.4-1.3.8-1.8,1.3v-2.7h-4.1v26.1h4.1v-13.1c0-2.6.6-4.6,1.7-6,1.7-2,3.7-2.9,6-2.9s4.1.8,5.5,2.4c1.5,1.6,2.2,3.7,2.2,6.4s-.7,4.9-2.2,6.5c-1.4,1.6-3.2,2.4-5.6,2.4h-5.4v4.2h5.4c3.4,0,6.3-1.2,8.5-3.7,2.2-2.4,3.4-5.6,3.4-9.5s-1.1-7-3.3-9.5h0ZM250.7,15.3c0,2.6-.7,4.7-2.1,6.3-1.4,1.6-3.2,2.3-5.6,2.3h-2V2.1h-4.1v21.9h-5.8v4.2h11.9c3.5,0,6.4-1.2,8.5-3.6,2.2-2.4,3.3-5.5,3.3-9.2V2.1h-4.1v13.2s0,0,0,0ZM192.3,35.1h4.1V2.1h-4.1v33.1ZM209.6,6.5h8.8c2.2.4,3.8,1.3,4.6,2.6.8,1.3,1.2,3.4,1.2,6.2v12.8h4.1v-12.8c0-4-.7-7-2-8.9h3.4V2.1h-20.2v4.4h0,0ZM200.7,28.2h4.1V2.1h-4.1v26.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M104.6,309.4h-22.9v-25.1h11.6c3.4,0,6.2,1.2,8.2,3.5,2.1,2.3,3.1,5.3,3.1,9.2v12.4ZM98.6,302.6v-5.6c0-3.5-2.1-5.8-5.3-5.8h-5.5v11.4h10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M115,295.9h-6.1v-11.7h6.1v11.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.9,305.9c-2.1,2.3-4.8,3.5-8.2,3.5h-11.4v-6.8h11.4c2.9,0,5.2-2.2,5.2-5.9s-2.1-5.8-5.2-5.8-2.3.3-3.2.8c-1,.6-1.5,1.5-1.5,2.6h4.8v4.8h-11.4v-2.7c0-3.7,1.1-6.7,3.1-9s4.9-3.4,8.2-3.4,6.1,1.2,8.2,3.5c2.1,2.3,3.2,5.4,3.2,9.2s-1.1,6.9-3.2,9.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M152.5,309.4h-6.1v-25.1h6.1v25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M176.1,306.2c-2.1,2.3-4.8,3.5-8.1,3.5s-6.1-1.1-8.2-3.4c-2.2-2.3-3.2-5.3-3.2-9.1v-12.9h6.1v13c0,3.1,2.2,5.6,5.4,5.6s5-2.1,5-5.6-1.7-6.3-5-6.3h-1.2v-7h1.2c3.6,0,6.3,1.2,8.4,3.7,1.9,2.4,2.9,5.5,2.9,9.5s-1.1,6.8-3.2,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M205.6,309.4h-6.1v-12.7c0-3.9-1.7-5.8-5-5.8s-5.5,1.9-5.5,5.8v12.7h-6.1v-25.2h6.1v2c.4-.7,1.3-1.3,2.5-1.7,1-.3,2-.5,3-.5,3.3,0,6,1.2,8,3.6,2.1,2.4,3.1,5.4,3.1,9.2v12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M232.8,309.4h-6.1v-12.4c0-2-.5-3.4-1.5-4.5-.9-.9-2.1-1.3-3.6-1.3h-11.6v-6.9h11.3c3.4,0,6.1,1.2,8.2,3.5,2.1,2.3,3.2,5.4,3.2,9.2v12.4ZM216.5,309.4h-6v-12.4h6v12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M276.5,309.4h-22.9v-25.1h11.6c3.4,0,6.2,1.2,8.2,3.5,2.1,2.3,3.1,5.3,3.1,9.2v12.4ZM270.4,302.6v-5.6c0-3.5-2.1-5.8-5.3-5.8h-5.5v11.4h10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.1,297c0,3.7-1.1,6.7-3.2,9-2.1,2.3-4.9,3.4-8.2,3.4h-11.3v-6.8h3.5v-18.3h6.1v18.3h1.7c3.5,0,5.3-1.9,5.3-5.6v-12.7h6.1v12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.4,309.4h-6.1v-25.1h6.1v25.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.7,309.4h-10.1v-6.8h4v-5.8c0-1.7-.2-3-.5-3.8-.5-1.1-1.4-1.9-2.7-2.2v-6.7c3,0,5.3,1.3,7.1,4,1.5,2.3,2.2,5.2,2.2,8.7v12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M370.7,309.4h-6.1v-12.7c0-3.9-1.7-5.8-5-5.8s-5.5,1.9-5.5,5.8v12.7h-6.1v-25.2h6.1v2c.4-.7,1.3-1.3,2.5-1.7,1-.3,2-.5,3-.5,3.3,0,6,1.2,8,3.6,2.1,2.4,3.1,5.4,3.1,9.2v12.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M385,309.4h-10.1v-6.8h4v-5.8c0-1.7-.2-3-.5-3.8-.5-1.1-1.4-1.9-2.7-2.2v-6.7c3,0,5.3,1.3,7.1,4,1.5,2.3,2.2,5.2,2.2,8.7v12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M415.1,309.4h-7.5l-10.7-14.3v14.3h-6.1v-22.6l-1.7-2.5h7.5l6.3,8.6c1.4-.2,2.5-.5,3.3-.9,1.2-.6,1.8-2,1.8-3.9v-3.8h6.1v3.8c0,3.1-.5,5.5-1.4,7.1-1,1.7-2.9,2.9-5.5,3.6l7.9,10.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M457.9,309.4h-22.9v-25.1h11.6c3.4,0,6.2,1.2,8.2,3.5,2.1,2.3,3.1,5.3,3.1,9.2v12.4ZM451.8,302.6v-5.6c0-3.5-2.1-5.8-5.3-5.8h-5.5v11.4h10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M473.2,309.4h-6.1v-4.3c-.3,1.1-1,2.3-2,3.3-1.1,1.1-2.2,1.6-3.3,1.6v-7c3.6-.4,5.2-2,5.2-6s-.4-3.4-1.3-4.4c-.8-.8-2.1-1.4-3.9-1.6v-7c3.2,0,5.8,1,7.9,2.9,2.3,2.1,3.4,4.9,3.4,8.4v14Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.7,236.4v-125.5c0-5.6-4.5-10.1-10.1-10.1h-18.3c-5.6,0-10.1,4.5-10.1,10.1v125.5c0,5.6,4.5,10.1,10.1,10.1h18.3c5.6,0,10.1-4.5,10.1-10.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    x: 315.1,
    y: 127.6,
    width: 38.5,
    height: 118.9,
    rx: 10.2,
    ry: 10.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M291.7,77.8v-18.2c0-5.6-4.5-10.1-10.1-10.1h-18.2c-5.6,0-10.1,4.5-10.1,10.1v18.2c0,5.6,4.5,10.1,10.1,10.1h18.2c5.6,0,10.1-4.5,10.1-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M500.1,147c0-.4,0-.8,0-1.2,0-51.4-41.6-93.1-93-93.2h-70.8c-10.6,0-19.2,8.6-19.2,19.2s8.6,19.2,19.2,19.2h70.5c30.2,0,54.8,24.5,54.8,54.8s0,.8,0,1.2h0c0,.1,0,.2,0,.3v89c0,5.6,4.5,10.2,10.2,10.2h18.2c5.6,0,10.2-4.5,10.2-10.2v-89c0-.1,0-.2,0-.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.5,50.8c-9.8,0-19.3,1.5-28.2,4.2v41.5c8.4-4.6,18-7.2,28.2-7.2,32.5,0,58.9,26.4,58.9,58.9s-26.4,58.9-58.9,58.9-58.9-26.4-58.9-58.9,0-1.8,0-2.6v-76.8c0-10.6-8.6-19.2-19.2-19.2s-19.2,8.6-19.2,19.2v77.7c0,.2,0,.4,0,.6,0,.4,0,.8,0,1.2,0,53.8,43.6,97.4,97.4,97.4s97.4-43.6,97.4-97.4-43.6-97.4-97.4-97.4h0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19,230.5s3.7,15.3,15.3,30.3c17.1,22,44.5,69,44.5,69,0,0-4.1,5.2-5.4,6.9-2.7,3.7-10.7,15.1-10.7,15.1,0,0-34-55.8-38.2-62.8-4.2-7-15.1-29.1-15.6-38.3,0-.4,0-3,0-3.5.8-11.3,9.9-16.8,9.9-16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.7,243.1c.5-1.4,4.9-17.8,26.8-17.8,20.7,0,25.9,17.8,25.9,17.8,0,0-2.2-7.8-10.4-25.4-.9-2-4.3-6.6-15.5-6.8-12.6-.2-15.1,3.5-16.5,6.8-7.4,16.3-10.2,25.4-10.2,25.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.8,229.5s-2.7,15.6-13.1,31.6C23.5,284.4,0,333.5,0,333.5c8.5,7.7,6.4,5.8,8.3,7.8,2.7,2.8,9.7,11.5,9.7,11.5,0,0,29-57,32.7-64.3,3.7-7.3,13.6-30.7,12.3-41.5-1.5-12.5-11.2-17.5-11.2-17.5Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.8,250.1s0,0,0,0c0,0,0,0,0,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M63.1,248.7c-.2-13.4-12.1-23.6-27-23.7h0s0,0,0,0,0,0,0,0h0c-14.9,0-27,10.3-27,23.7s.2,3.5.6,5.2c-.3-1.3-.4-2.8-.4-4.2s0-1.7.2-2.5c1-12.4,12.6-21.7,26.6-21.7,14.1,0,25.7,9.3,26.7,21.7.1.8.2,1.7.2,2.5,0,1.3,0,2.3,0,2.4,0,0,.2-1.6.2-3.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYellow);
export default __webpack_public_path__ + "static/media/logo_yellow.90fcefc544318703ed3db8b9ed9de725.svg";
export { ForwardRef as ReactComponent };